<template>
  <div> 
    <Spin fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
    import utils from "@/utils";
    import config from "@/config";
    
    export default {
        name:'preview-file',
        data(){
            return {
               spinShow:true 
            }
        },
        created(){
            this.initInfo();
        },
        methods:{
            initInfo(){
                let url = this.$route.query.url;
                if(url){
                    //任务反馈附件预览
                    // window.location.href = `${config.server.url}${config.server.prefix}/redirect-preview?url=${window.btoa(url)}`;
                    window.location.href = `${url}`;
                    return;
                }
             
            }
        }
    }
</script>

<style lang="less" scoped>
.ivu-spin-fix {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
}
</style>
